import React, { Component } from 'react';
import DayMachineElement from './DayMachineElement';
import './styles/machine-layout.css';
import dayjs from 'dayjs';

class MachineLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 3, 'fac');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0 || dateNum == today.get('date'))) {
        return 'emtpy_state';
      }

      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (issueOfDay.countMachineTotal <= 1 && issueOfDay.countMachineKeyTotal <= 0) {
        return 'green_state';
      }

      if (issueOfDay.countMachineTotal >= 2 && issueOfDay.countMachineKeyTotal <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countMachineTotal >= 1 && issueOfDay.countMachineKeyTotal > 0) {
        return 'red_state';
      }

      if (!issueOfDay.countMachineTotal || issueOfDay.countMachineTotal <= 0) {
        return 'green_state';
      }

      return 'red_state';
    }

    return 'emtpy_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayMachineElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-machine">
          {/* Elements 1-4 */}
          {this.populateElements(1, 31)}
          {/* Information Table */}
        </div>
        <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
          Machine
        </h3>
      </>
    );
  }
}

export default MachineLayout;
